import React, { Component } from "react";
import { Spin } from "antd";
import LabListView from "./LabListView";
import { getLabList } from "../../services/labService";
import { strings, showErrorNotification, history } from "../../helpers";

export default class LabListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      labList: [],
      isProcessing: false,
      totalRecords: 0,
      totalPage: 0,
      pageNo: 1,
      searchText: "",
      stateName: ""
    };
  }
  componentDidMount() {
    this.getLabList();
  }

  /**
   * @function getLabList
   * @description This function get Lab data
   */
  getLabList = () => {
    const { pageNo, searchText, stateName } = this.state;
    this.setState({
      isProcessing: true
    });
    getLabList(pageNo, searchText, stateName)
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response.data.success) {
          const { labs } = response.data.data;
          const { total_records } = response.data.data;
          const { total_pages } = response.data.data;
          this.setState({
            labList: labs,
            totalRecords: total_records,
            totalPages: total_pages
          });
        } else {
          this.setState({
            labList: [],
            isProcessing: false,
            totalRecords: 0,
            totalPages: 0
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({ labList: [], isProcessing: false });
      });
  };

  /**
   * @function onPageChange
   * @param page
   * @description This function get called on page change
   */
  onPageChange = page => {
    this.setState({ pageNo: page, labList: [] }, () => {
      this.getLabList();
    });
  };

  /**
   * @function handleSearch
   * @description This function get called when clicked on pres button
   */
  handleSearch = () => {
    this.setState({ pageNo: 1, labList: [] }, () => {
      this.getLabList();
    });
  };

  /**
   * @function handleStateChange
   * @description This function get called when clicked on search icon
   */
  handleStateChange = e => {
    this.setState({ stateName: e.target.value });
  };

  /**
   * @function handleSearchText
   * @description This function get called when clicked on search icon
   */
  handleSearchText = e => {
    this.setState({ searchText: e.target.value });
  };

  /**
   * @function  handleStateSearch
   * @description This function get called when clicked on press enter
   */
  handleStateSearch = () => {
    this.setState({ pageNo: 1, labList: [] }, () => {
      this.getLabList();
    });
  };

  /**
   * @function  navigateToLabDetails
   * @param "e","clinicId"
   * @description This function redirect the user to clinic-details
   */
  navigateToLabDetails = (e, labId) => {
    e.preventDefault();
    history.push(`/lab-details/${labId}/basic-details`);
  };

  render() {
    const {
      labList,
      isProcessing,
      totalRecords,
      totalPages,
      pageNo,
      searchText,
      stateName
    } = this.state;
    return (
      <Spin spinning={isProcessing}>
        <LabListView
          labList={labList}
          allRecords={totalRecords}
          allPages={totalPages}
          pageNo={pageNo}
          stateName={stateName}
          searchText={searchText}
          navigateToLabDetails={this.navigateToLabDetails}
          onPageChange={this.onPageChange}
          handleSearchText={this.handleSearchText}
          handleSearch={this.handleSearch}
          handleStateChange={this.handleStateChange}
          handleStateSearch={this.handleStateSearch}
        />
      </Spin>
    );
  }
}
